export const IconDelete2 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path
      fill="#122B46"
      fillOpacity="0.5"
      d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm0 1.5c4.703 0 8.5 3.797 8.5 8.5 0 4.703-3.797 8.5-8.5 8.5A8.489 8.489 0 011.5 10c0-4.703 3.797-8.5 8.5-8.5zm3.243 4.49a.75.75 0 00-.523.23L10 8.94 7.28 6.22a.75.75 0 10-1.06 1.06L8.94 10l-2.72 2.72a.75.75 0 101.06 1.06L10 11.06l2.72 2.72a.75.75 0 101.06-1.06L11.06 10l2.72-2.72a.75.75 0 00-.537-1.29z"
    ></path>
  </svg>
)
